/**
 * Author：brand
 * Creation Time：2019-05-11 10:43
 * Email：brandhuang@qq.com
 */

import * as auth from './modules/auth'

export default {
  ...auth
}
